import { useState } from 'react';
import { CiCircleRemove } from 'react-icons/ci';
import { FaRegEdit } from 'react-icons/fa';
import { IoIosClose } from "react-icons/io";
import { RiErrorWarningLine } from "react-icons/ri";
import { Link } from 'react-router-dom';
import "./Notifications.scss";
import { GoPerson } from "react-icons/go";
import { IoSearch } from "react-icons/io5";
import user from "../../Assets/user.png";
import { CiEdit } from "react-icons/ci";
import { IoIosArrowDown } from "react-icons/io";

import Replay from '../Replay/Replay';import { BsBell } from 'react-icons/bs';
export default function Notifications() {
    const requestsData = [
  {
    id: 1,
    title: "Name Client",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus mollitia cum animi dolor alias!jjjjjjjjjjjjjjjjjjjjytfyuijjjjjjjjjjjjjjjjjjjjytfyui",
    date: "Feb 1 [4:30 PM]",
  },
    {
    id: 1,
    title: "Name Client",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus mollitia cum animi dolor alias!jjjjjjjjjjjjjjjjjjjjytfyuijjjjjjjjjjjjjjjjjjjjytfyui",
    date: "Feb 1 [4:30 PM]",
  },
    {
    id: 1,
    title: "Name Client",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus mollitia cum animi dolor alias!jjjjjjjjjjjjjjjjjjjjytfyuijjjjjjjjjjjjjjjjjjjjytfyui",
    date: "Feb 1 [4:30 PM]",
  },
    {
    id: 1,
    title: "Name Client",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus mollitia cum animi dolor alias!jjjjjjjjjjjjjjjjjjjjytfyuijjjjjjjjjjjjjjjjjjjjytfyui",
    date: "Feb 1 [4:30 PM]",
  },
    {
    id: 1,
    title: "Name Client",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus mollitia cum animi dolor alias!jjjjjjjjjjjjjjjjjjjjytfyuijjjjjjjjjjjjjjjjjjjjytfyui",
    date: "Feb 1 [4:30 PM]",
  }
];

const clients = [
  {
    id: 1,
    name: "John Doe",
    email: "john@example.com",
    time: "4:35 PM",
    title: "Name Client",
    description: "Lorem ipsum dolor sit amet...",
    date: "Feb 1 [4:30 PM]",
  },
  {
    id: 2,
    name: "Jane Smith",
    email: "jane@example.com",
    time: "3:20 PM",
    title: "Name Client",
    description: "Another message here...",
    date: "Feb 2 [3:20 PM]",
  },
 {
    id: 2,
    name: "Jane Smith",
    email: "jane@example.com",
    time: "3:20 PM",
    title: "Name Client",
    description: "Another message here...",
    date: "Feb 2 [3:20 PM]",
  },
   {
    id: 2,
    name: "Jane Smith",
    email: "jane@example.com",
    time: "3:20 PM",
    title: "Name Client",
    description: "Another message here...",
    date: "Feb 2 [3:20 PM]",
  },
   {
    id: 2,
    name: "Jane Smith",
    email: "jane@example.com",
    time: "3:20 PM",
    title: "Name Client",
    description: "Another message here...",
    date: "Feb 2 [3:20 PM]",
  },
   {
    id: 2,
    name: "Jane Smith",
    email: "jane@example.com",
    time: "3:20 PM",
    title: "Name Client",
    description: "Another message here...",
    date: "Feb 2 [3:20 PM]",
  },
   {
    id: 2,
    name: "Jane Smith",
    email: "jane@example.com",
    time: "3:20 PM",
    title: "Name Client",
    description: "Another message here...",
    date: "Feb 2 [3:20 PM]",
  },
   {
    id: 2,
    name: "Jane Smith",
    email: "jane@example.com",
    time: "3:20 PM",
    title: "Name Client",
    description: "Another message here...",
    date: "Feb 2 [3:20 PM]",
  },
   {
    id: 2,
    name: "Jane Smith",
    email: "jane@example.com",
    time: "3:20 PM",
    title: "Name Client",
    description: "Another message here...",
    date: "Feb 2 [3:20 PM]",
  },
   {
    id: 2,
    name: "Jane Smith",
    email: "jane@example.com",
    time: "3:20 PM",
    title: "Name Client",
    description: "Another message here...",
    date: "Feb 2 [3:20 PM]",
  },
  
];

  const [open, setOpen] = useState(false);

  return (
    <div className='row p-0 allnotfications m-0'>
      <div className='col-3 notfications'>
        <div className='not-nav'>
            <div className=' d-flex align-items-center gap-2'>
                 <img src={user} className="user-img" alt="User" height={35} width={35} />
                 <div>
                    <span style={{color:"white", fontWeight:"bold", marginRight:"6px"}}>Notification</span>
               <span style={{
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "20px",
  height: "20px",
  backgroundColor: "#ba2c34",
  color: "white",
  borderRadius: "50%",
  border:"3px solid #d58085",
  fontSize: "12px"
}}>
  10
</span>

                    </div> 


            </div>
            <div style={{
                color:"white",
                display:"flex",
                gap:"10px",
                alignItems:"center"
            }}>  
          <Link to="/dashboard/Notification-Rings" style={{ textDecoration: 'none', color: 'inherit' }}>
  <BsBell className='icone' />
</Link>

                
                 <span className='active'>
 <CiEdit  className='icone '/>
                 </span>
                 <IoIosArrowDown className='icone'/>

            </div>
              
        </div>

        <div className='p-3'>
            <div className='content-search'>
     <div className="search-wrapper">

  <IoSearch className="search-icon" />
  <input
    type="text"
    placeholder="Search Client"
    className="search-client"
  />
</div>
            </div>


        
       {clients.map((item) => (
  <div key={item.id}>
    <input type="checkbox" />
    <div className="gap-4 d-flex ">
      <div className=''>
        <span className="personal-img">
          <GoPerson />
        </span>

        <div className="whitecircle">
          <div className="online"></div>
        </div>
      </div>

      <div className='  w-100'>
        <div>
          <div className="d-flex flex-column mb-3">
            <div className="d-flex align-items-center justify-content-between ">
              <span>{item.name}</span>
                          <span style={{ color: "#666666", fontSize: "13px" }}>[{item.time}]</span>
            </div>
                          <span style={{ color: "#666666", fontSize: "14px" }}>{item.email}</span>

          </div>
          <div className="under-line"></div>
        </div>
      </div>
    </div>
  </div>
))}
        </div>
 


      </div>

       <div className="request-page col-9">
        <div className="sup-nav">
          <span className=' d-flex align-items-center gap-5'>Save in <IoIosArrowDown style={{color:"#858d9d"}}/></span>
           <span>Date</span>
            <span>Create note</span>
             <span>Delete</span> 
             <span className=' d-flex align-items-center gap-5'>Topic <IoIosArrowDown style={{color:"#858d9d"}}/></span>
        </div>
        <div className=' p-3'>
      {open && (
            <div className="replay-overlay">
              <div className="replay-modal">
                <Replay />
                <button className="close-modal" onClick={() => setOpen(false)}>×</button>
              </div>
            </div>
          )}
  
          {requestsData.map((request) => (
            <div key={request.id} className="request-content w-100">
              <div className="request-header">
                <div className="d-flex align-items-center gap-3  ">
                    <div>
 <img src={user} className="user-img" alt="User" height={50} width={50} />

        <div className="greencircle">
          <div className="online"></div>

        </div>
                    </div>
<div>               
<div className=' d-flex align-items-center justify-content-between'>
<span className="title">{request.title}</span>
                   <IoIosClose className="icon close" />
</div>
                  
              <p className="request-description">{request.description}</p>
                  <div className="d-flex align-items-center  w-100 justify-content-between">
                <div className="faq-actions">
                  <button className="edit">Closed <FaRegEdit /></button>
                  <button className="remove" onClick={() => setOpen(true)}>Reply <CiCircleRemove /></button>
                </div>
                <p>{request.date}</p>
              </div>

</div>
                </div>         
                     </div>
    
    
            </div>
          ))}
    
          <div className="table-footer">
            <div className="showing-info">Showing 17 of 100</div>
            <div className="pagination">
              <button className="active">1</button>
              <button>2</button>
              <button>3</button>
              <button>4</button>
              <button>5</button>
              <button>Next</button>
            </div>
          </div>
        </div>
    
        </div>
    </div>
  )
}
 